import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-lg mx-auto text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold sm:text-3xl" }, "Now Let's find your house!"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-gray-500" }, [
    /*#__PURE__*/_createTextVNode(" Enter your address into the field below and claim your residence. If you believe your residence has already been claimed by mistake please reach out to "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@foxwoodcrossing.com" }, "support@foxwoodcrossing.com")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "max-w-md mx-auto mt-8 mb-0 space-y-4"
}
const _hoisted_4 = { class: "p-1 shadow-xl bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 rounded-2xl" }
const _hoisted_5 = {
  class: "block px-6 bg-white sm:p-8 rounded-xl",
  href: ""
}
const _hoisted_6 = { class: "mt-2 sm:pr-8" }
const _hoisted_7 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-gray-500"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-2 text-sm text-yellow-700"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "block px-8 py-3 text-sm font-medium bg-white rounded-full hover:bg-transparent" }, " Oops, wrong house ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, " Next ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5 ml-3",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M14 5l7 7m0 0l-7 7m7-7H3"
  })
], -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "max-w-md mx-auto mt-8 mb-0 space-y-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "address",
  class: "sr-only"
}, "Address", -1)
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 inline-flex items-center right-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 text-gray-300",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    })
  ])
], -1)
const _hoisted_19 = { class: "flex justify-center" }
const _hoisted_20 = {
  key: 0,
  class: "bg-white rounded-lg border border-gray-200 w-96 text-gray-900"
}
const _hoisted_21 = ["onClick"]

import { HoodApi } from "@/services/HoodApi";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  emits: ["address-set"],
  setup(__props, { emit }) {

const addressLookup = ref("");
const results = ref<House[]>([]);
const selectedHouse = ref<House>();
const houseIsSelected = ref(false);
const showResults = ref(false);



const handleInput = async () => {
  console.log("here");
  console.log(addressLookup.value);
  results.value = await HoodApi.house_lookup(addressLookup.value);
  if (results.value.length > 0) {
    showResults.value = true;
  }
};

const selectAddress = (house: House) => {
  console.log(house);

  selectedHouse.value = house;
  houseIsSelected.value = true;
  addressLookup.value = "";
  results.value = [];
  showResults.value = false;
};

const clear = () => {
  selectedHouse.value = {} as House;
  houseIsSelected.value = false;
};

const done = () => {
  emit("address-set", selectedHouse.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (houseIsSelected.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h5", _hoisted_7, _toDisplayString(selectedHouse.value.house_number) + " " + _toDisplayString(selectedHouse.value.street), 1),
                (selectedHouse.value.status === 'unclaimed')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, " This house is available! Complete your registration to claim it. "))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, " This house is currently registered to another resident. You can still complete registration and we'll review your ownership claim. "))
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "inline-block p-[2px] rounded-full bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:text-white active:text-opacity-75 focus:outline-none focus:ring",
            onClick: clear
          }, _hoisted_11),
          _createElementVNode("button", {
            onClick: done,
            class: "inline-flex items-center justify-center w-full px-5 py-3 text-white bg-black rounded-lg sm:w-auto"
          }, _hoisted_14)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", null, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addressLookup).value = $event)),
                class: "w-full p-4 pr-12 text-sm border-gray-200 rounded-lg shadow-sm",
                placeholder: "Enter your address",
                onKeyup: handleInput
              }, null, 544), [
                [_vModelText, addressLookup.value]
              ]),
              _hoisted_18
            ]),
            _createElementVNode("div", _hoisted_19, [
              (showResults.value)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "px-6 py-2 border-b border-gray-200 w-full rounded-t-lg hover:bg-blue-400",
                        onClick: ($event: any) => (selectAddress(item))
                      }, _toDisplayString(item.house_number) + " " + _toDisplayString(item.street), 9, _hoisted_21))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
  ]))
}
}

})